import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  standalone: false,
  selector: 'app-redirect',
  template: '',
})
export class MsalRedirectComponent implements OnInit {
  public constructor(private msalService: MsalService) {}

  public ngOnInit(): void {
    // eslint-disable-next-line nimbus/prefer-until-destroyed
    this.msalService.handleRedirectObservable().subscribe();
  }
}
